<template>
  <div class="draggable-item-container">
    <el-collapse-item :name="data.type">
      <template slot="title">
        <span>
          <i :class="data.titleClass"></i>&nbsp;{{data.title}}
        </span>
        <span @click.stop.prevent="addFirstMenu(data.type, data.index)" class="add-first-menu">
            <b class="el-icon-plus"></b>{{ data.type === 'function' ? '添加功能点' : '添加模块' }}
          </span>
      </template>
      <draggable v-if="!showList" v-model="list" @end="updateArray">
        <div class="list-item"
             v-if="data.filterText ? item.name.includes(data.filterText) : true"
             :class="data.listItemActiveId === item.id && 'active-item'"
             v-for="(item, index) in list"
             :key="item.id">
          <span class="item-name" @click.stop="menuClick(item, data.type)">{{item.name}}</span>
          <el-tooltip popper-class="menu-tree-tooltip" effect="dark" content="删除" placement="bottom">
            <span v-if="getDisable(item)" class="el-icon-delete" @click.stop="deleteMenu(index, data.index, item)"></span>
          </el-tooltip>
        </div>
      </draggable>
      <div v-else class="none-data">暂无数据</div>
    </el-collapse-item>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
export default {
  name: 'draggable-item',
  components: {Draggable},
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          titleClass: '',
          type: '',
          filterText: '',
          listItemActiveId: '',
          list: [],
          index: 0,
          title: ''
        }
      }
    }
  },
  data () {
    return {
      list: []
    }
  },
  methods: {
    addFirstMenu (type, index) {
      this.$emit('addFirstMenu', type, index)
    },
    menuClick (item, type) {
      this.$emit('menuClick', item, type)
    },
    deleteMenu (i, j, item) {
      this.$emit('deleteMenu', i, j, item)
    },
    // 直接使用 props传递进来的list视图上虽然是更新了顺序，但是列表实际没有更改，所以copy了一份替代
    // 拖动结束，更新数组
    updateArray () {
      this.$emit('updateArray', this.data.index, this.list)
    }
  },
  watch: {
    'data.list': {
      handler (val) {
        if (val) {
          this.list = this.$_.cloneDeep(val)
        }
      },
      deep: true
    }
  },
  computed: {
    showList () {
      if (this.data.filterText) {
        return this.list.filter(c => c.name.includes(this.data.filterText)).length === 0
      } else {
        return this.list.length === 0
      }
    },
    getDisable () {
      return data => parseInt(data.isBuiltIn) !== 1
    }
  }
}
</script>

<style lang="scss">
  .draggable-item-container {
    .el-collapse-item {
      .el-collapse-item__wrap {
        .none-data {
          height: 50px;
          line-height: 50px;
          text-align: center;
          color: #909399;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/system/menu/draggable-item.vue